"use client";

import React from "react";
import { useParams } from "react-router-dom";
import AppLayout from "../../../navigation/Layout/Layout";
import DoctorProfileCard from "../../components/DoctorDetailsPage/DoctorProfileCard/DoctorProfileCard";
import AppointmentScheduler from "../../components/DoctorDetailsPage/AppointmentScheduler/AppointmentScheduler";
import AppointmentSummary from "../../components/DoctorDetailsPage/AppointmentSummary/AppointmentSummary";
import useDoctorDetailsPage from "../../../appointments/hooks/useDoctorDetailsPage";
import "./DoctorDetails.css";

export default function DoctorDetails() {
  const { doctorId } = useParams();
  const { doctor, notFound } = useDoctorDetailsPage();

  if (notFound) {
    return (
      <AppLayout>
        <div className="dd-root">
          <main className="dd-main">
            <div className="dd-container">
              <div className="dd-notfound">Doctor not found</div>
            </div>
          </main>
        </div>
      </AppLayout>
    );
  }

  return (
    <AppLayout>
      <div className="dd-root">
        <main className="dd-main">
          <div className="dd-container">
            <div className="dd-grid">
              <div className="dd-left">
                <div className="dd-card dd-card--pad">
                  <DoctorProfileCard doctor={{ ...doctor, id: doctor?.id || doctorId }} size="md" rounded="lg" />
                </div>
                <div className="dd-card dd-card--pad-sm">
                  <AppointmentSummary doctor={doctor} />
                </div>
              </div>

              {/* Colonne droite */}
              <div className="dd-right">
                <div className="dd-card dd-card--pad-lg">
                  <AppointmentScheduler doctor={{ ...doctor, id: doctor?.id || doctorId }} />
                </div>
              
              </div>
            </div>
          </div>
        </main>
      </div>
    </AppLayout>
  );
}
